/**
 * Dropdown menu items actions.
 * @module actions/getDropdownMenuNavitems
 */
import {
  GET_BOWLINGCENTERPRODUCTSICON,
  GET_BOWLINGCENTERSEARCH,
  GET_CONTACTSFORMINFO,
  GET_QBASESNATIONLIST,
  SUBMIT_CONTACTSFORM,
} from '@redturtle/qubicaamf-theme/constants/ActionTypes';
export const GET_DROPDOWNMENU_NAVITEMS = 'GET_DROPDOWNMENU_NAVITEMS' as const;

/**
 * Get dropdown menu items.
 * @function getDropdownMenuNavitems
 * @returns {Object} Get dropdown menu items action.
 * Es: http://localhost:8080/Plone/@dropdown-menu
 */
export function getDropdownMenuNavitems() {
  return {
    type: GET_DROPDOWNMENU_NAVITEMS,
    request: {
      op: 'get',
      path: `/@dropdown-menu`,
    },
  };
}

/**
 * Get breadcrumbs.
 * @function getBowlingCenterProductsIcon
 * @param {string} url Content url.
 * @returns {Object} Get breadcrumbs action.
 */
export function getBowlingCenterProductsIcon() {
  return {
    type: GET_BOWLINGCENTERPRODUCTSICON,
    request: {
      op: 'get',
      path: '/@bowling_center_product_icons',
    },
  };
}

/**
 * Get breadcrumbs.
 * @function getBowlingCenterProductsIcon
 * @param {string} url Content url.
 * @returns {Object} Get breadcrumbs action.
 */
export function getBowlingCenterSearch(search, currentUID) {
  return {
    type: GET_BOWLINGCENTERSEARCH,
    request: {
      op: 'post',
      path: '/@bowling_center_search',
      data: { search, currentUID },
    },
  };
}

// topLevelData is merged as a sibling of `data`, not inside it: collective.honeypot
// only inspects the top-level POST body keys, while the backend form service only
// reads the nested `data` key, so the honeypot field must live at the top level.
export function submitContactForm(endpoint, data, topLevelData = {}) {
  return {
    type: SUBMIT_CONTACTSFORM,
    request: {
      op: 'post',
      path: endpoint,
      data: { data, ...topLevelData },
    },
  };
}

export const resetSubmitContactForm = () => ({
  type: 'RESET_SUBMIT_CONTACT_FORM',
});

export function getContactFormInfo() {
  return {
    type: GET_CONTACTSFORMINFO,
    request: {
      op: 'get',
      path: '/@form-configuration',
    },
  };
}

export function getQBasesNationList() {
  return {
    type: GET_QBASESNATIONLIST,
    request: {
      op: 'get',
      path: '/@find-locales-list',
    },
  };
}
